export default function formatLocationTag(tag) {
	tag.iconType = 'bp';
	if (tag.type === 'postalCode') {
		//There should probably be a better way to format the label -- like having it properly cased in the database
		tag.label = `${tag.postalPlace} (${tag.postalCode})`;
		tag.icon = 'map-marker';
	}
	if (tag.type === 'polygon-filter') {
		if (tag.radiusValue && tag.radiusValue > 0)
			tag.label = `${tag.name} +${tag.radiusValue} km`;
		else
			tag.label = tag.name;
		tag.icon = 'polygon-filter';
	}
	if (tag.type === 'address') {
		tag.label = tag.name;
		tag.icon = 'home';
	}
	if (tag.type === 'countryCode') {
		tag.icon = 'globe';
	}
	if (tag.op === 'NOT') {
		tag.op = 'NOT';
		tag.color = 'red';
	}
	return tag;
}